import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {
  PolicyGridViewModel
} from '@program-suite/data-common';

@Injectable({
  providedIn: 'root',
})
export class PolicyGridService {
  http = inject(HttpClient);

  /**
   * get policy grid
   * @returns 200 - OK(PolicyGridViewModel)
   * @throws Error if fails
   */
  async getPolicyGrid(params: any): Promise<PolicyGridViewModel> {
    try {
      return await firstValueFrom(this.http.get('policy/policies', {params, responseType: 'json' }));
    } catch (error) {
      throw new Error('Something went wrong, please try again');
    }
  }
}
